/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {MediaTypeHelper} from '../../../components/util/media-type-helper';

export function formatMediaTypeKey(mimeType: any): string {
  const mediaType = MediaTypeHelper.getMediaType(mimeType);
  return mediaType ? 'media.' + mediaType.id : '';
}

export function formatMediaTypesTranslate(mimeTypes: any, translateInstant: (key: string) => string): string {
  const types = _.isArray(mimeTypes) ? mimeTypes : [mimeTypes];
  const mediaTypes = _.map(types, (mimeType) => MediaTypeHelper.getMediaType(mimeType));
  const translations = _.map(_.uniq(_.compact(mediaTypes)), (mediaType) => translateInstant('media.' + mediaType.id));
  return translations.join(', ');
}
